import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';

import { PromoCompilationItem } from '../../../../components/PromoCompilation';
import { ICompilation } from '../../../../types/promosPage';
import { getPromoCompilationAnalytics, getPromoCompilationBackground } from '../../helpers';

export interface IPromoCompilationItemProps {
  compilation: ICompilation;
}

export const PromoCompilationItemContainer: React.FC<IPromoCompilationItemProps> = ({ compilation }) => {
  const { type } = compilation;

  const background = getPromoCompilationBackground(type);
  const { trackAfterView, trackClick } = getPromoCompilationAnalytics(type);

  return (
    <ActionAfterViewObserver callback={trackAfterView} wrapper={false}>
      <PromoCompilationItem compilation={compilation} background={background} onClick={trackClick} />
    </ActionAfterViewObserver>
  );
};
